<template>
  <Navbar />

  <div class="bg-light" style="min-height: 100vh;">
    <div style="height: 75px;"></div>
    <div class="container">
      <div class="row align-items-center">
        <div style="font-size: 20px;" class="col-md-6 col-12 mb-2">
          <font-awesome-icon :icon="['fas', 'diagram-project']" /> รายการสถานที่
          <span class="ms-2 text-muted" style="font-size: 14px;">
            ({{ filteredItems.length }} / {{ items.length }})
          </span>
        </div>
        <div class="col-md-6 col-12 text-md-end mb-2">
          <span class="me-1">ค้นหาสถานที่</span>
          <input
            v-model.trim="message"
            @keyup.enter="onSearchEnter"
            placeholder=" ชื่อสถานที่"
            class="rounded-4 border px-2"
            style="height: 35px;width: 220px;"
          />
          <button
            type="button"
            class="btn text-white rounded-5 ms-1 px-2 py-1"
            style="background-color: #54ACEC"
            @click="onSearchEnter"
          >
            <font-awesome-icon :icon="['fas', 'magnifying-glass']" /> ค้นหา
          </button>
          <button
            v-if="message"
            type="button"
            class="btn btn-light border rounded-5 ms-1 px-2 py-1"
            @click="clearSearch"
            title="ล้างคำค้น"
          >
            <font-awesome-icon :icon="['fas', 'xmark']" />
          </button>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-12">

          <!-- Loading -->
          <div v-if="loading" class="text-center text-muted mt-5">
            <div class="spinner-border" role="status" style="width:2rem;height:2rem;"></div>
            <div class="mt-2">กำลังโหลดข้อมูล...</div>
          </div>

          <!-- Empty (no data at all) -->
          <div v-else-if="items.length === 0" class="text-center text-muted mt-5">
            <font-awesome-icon :icon="['fas', 'folder-open']" style="font-size: 32px;" />
            <div class="mt-2">ยังไม่มีรายการสถานที่</div>
          </div>

          <!-- No search match -->
          <div v-else-if="filteredItems.length === 0" class="text-center text-muted mt-5">
            <font-awesome-icon :icon="['fas', 'magnifying-glass']" style="font-size: 28px;" />
            <div class="mt-2">ไม่พบ "{{ message }}"</div>
            <button class="btn btn-link" @click="clearSearch">ล้างคำค้น</button>
          </div>

          <!-- Cards -->
          <div v-else class="row mt-3 g-3">
            <div
              class="col-12 col-sm-6 col-md-4 col-lg-3"
              v-for="(item, index) in filteredItems"
              :key="item.id || index"
            >
              <router-link
                style="text-decoration: none; color: inherit;"
                :to="{ path: '/inside', query: { name: item.name, id: item.id } }"
              >
                <div class="card border-0 grad rounded-5 shadow h-100" style="min-height: 165px;">
                  <div class="card-body">
                    <div class="row">
                      <div class="card-title col-10 text-truncate" style="color: #139CDA; font-size: 14px;">
                        <font-awesome-icon :icon="['fas', 'diagram-project']" /> {{ item.name }}
                      </div>
                      <div class="col-2 text-end">
                        <img src="../assets/rid_logo.png" alt="" width="20" />
                      </div>
                    </div>
                    <div style="font-size:14px" class="text-truncate">
                      Description: {{ item.description || '-' }}
                    </div>
                    <div style="font-size: 12px;">
                      <span>ละติจูด: {{ getLat(item) }}</span>
                      <span class="ms-2">ลองจิจูด: {{ getLng(item) }}</span>
                    </div>
                    <div style="font-size:14px">
                      สถานะการทำงาน :
                      <span :class="statusBadgeClass(item.status)" class="badge ms-1">
                        {{ statusLabel(item.status) }}
                      </span>
                    </div>
                    <div style="font-size: 12px;color: grey;" class="text-start text-truncate">
                      ID: {{ item.id }}
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import Navbar from "@/components/navbar_web.vue";

  export default {
    components: {
      Navbar
    },
    data() {
      return {
        loading: false,
        message: "",        // คำค้น (ก่อนหน้าไม่ได้ประกาศ → ทำให้ search ใช้ไม่ได้)
        selected: "ทั้งหมด",
        items: []
      };
    },
    computed: {
      // กรองรายการตามคำค้น (case-insensitive) ค้นได้ทั้งชื่อ / description / id
      filteredItems() {
        const q = (this.message || '').trim().toLowerCase();
        if (!q) return this.items;
        return (this.items || []).filter(it => {
          if (!it) return false;
          const fields = [it.name, it.description, it.id]
            .filter(v => v !== undefined && v !== null)
            .map(v => String(v).toLowerCase());
          return fields.some(f => f.includes(q));
        });
      }
    },
    created() {
      this.fetchListDataPlanAll();
    },
    methods: {
      async fetchListDataPlanAll() {
        this.loading = true;
        try {
          const token = localStorage.getItem('accessToken');
          const response = await axios.get(`${process.env.VUE_APP_API_URL}/api/page/plan`, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
          this.items = Array.isArray(response?.data?.data) ? response.data.data : [];
        } catch (error) {
          console.error('Error fetching page map:', error);
          this.items = [];
        } finally {
          this.loading = false;
        }
      },
      onSearchEnter() {
        // ค้นด้วย computed อยู่แล้ว ; ปุ่ม / Enter เป็นแค่ trigger ทาง UX
        // (เผื่อต่อไปอยากให้กด Enter ถึง refetch ก็ขยายตรงนี้)
      },
      clearSearch() {
        this.message = '';
      },
      // รองรับ key ทั้ง Latitude / latitude / lat
      getLat(item) {
        return item?.Latitude ?? item?.latitude ?? item?.lat ?? '-';
      },
      getLng(item) {
        return item?.Longitude ?? item?.longitude ?? item?.lng ?? item?.lon ?? '-';
      },
      statusLabel(status) {
        const s = Number(status);
        if (s === 0) return 'ไม่ทำงาน';
        if (s === 1) return 'ทำงานปกติ';
        if (s === 2) return 'ผิดปกติ';
        return '-';
      },
      statusBadgeClass(status) {
        const s = Number(status);
        if (s === 0) return 'bg-secondary';
        if (s === 1) return 'bg-success';
        if (s === 2) return 'bg-danger';
        return 'bg-light text-dark border';
      }
    }
  };
</script>


<style scoped>
  .customize-table {
    --easy-table-header-font-size: 18px;
    --easy-table-body-row-font-size: 16px;
  }

  .grad {
    /* background-image: linear-gradient(to right, #5487edda , #54aded67); */
    /* background: linear-gradient(to right, #139CDA, #139bdaa2); */
  }

  .card {
    transition: transform 0.15s ease, box-shadow 0.15s ease;
  }
  .card:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1) !important;
  }
</style>
